import { Button, ConfigProvider } from 'antd';
import { ButtonProps } from 'antd/es/button';
import React from 'react';

export const SuccessButton: React.FC<ButtonProps> = (props) => (
  <ConfigProvider
    theme={{
      components: {
        Button: {
          colorPrimary: '#52c41a',
          colorPrimaryHover: '#389e0d',
          colorPrimaryActive: '#237804',
        },
      },
    }}
  >
    <Button type="primary" {...props} />
  </ConfigProvider>
);
